interface RegexType {
  urlRegex: RegExp;
  numericRegex: RegExp;
  nonDigitCharacterRegex: RegExp;
  optionalLadingZerosRegex: RegExp;
  mobileNumberRegex: RegExp;
  filterEmojies: RegExp;
}
export const regex: RegexType = {
  urlRegex: /^[a-zA-Z0-9]+$/,
  nonDigitCharacterRegex: /[^0-9]/gi,
  optionalLadingZerosRegex: /0*(\d+)/,
  numericRegex: /^-?\d*(\d*)?$/,
  mobileNumberRegex: /^09\d{9}$/,
  // for ES6
  // filterEmojies:
  //   /[\u{1F300}-\u{1FAD6}\u{1F000}-\u{1F6FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{1F900}-\u{1FA6F}\u{1F600}-\u{1F64F}\u{1F680}-\u{1F6FF}]/gu,
  // for ES5
  filterEmojies:
    /[\uD83C[\uDF00-\uDFFF][\uDC00-\uDFFF]|\uD83D[\uDC00-\uDE4F\uDE80-\uDEFF]|\uD83E[\uDD00-\uDDFF\uDE70-\uDEFF\uDF00-\uDFFF]|\u2600-\u26FF|\u2700-\u27BF]/g,
};
